import { useEffect, useState } from 'react';
import { useI18n } from '../lib/i18n';
import { useOfflineFlush } from '../lib/queries';

/**
 * Top-of-screen banner shown when navigator.onLine flips to false. Also mounts
 * the offline queue flusher so queued status changes replay when connectivity
 * returns.
 */
export function OfflineBanner() {
  useOfflineFlush();
  const { t } = useI18n();
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  if (online) return null;
  return (
    <div className="bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950">
      {t('offline.banner')}
    </div>
  );
}
